/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Remove_Subject_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Remove all overrides?" |
*
* @param {Rights_Remove_Subject_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_remove_subject_confirm_title = /** @type {((inputs?: Rights_Remove_Subject_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Remove_Subject_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Ausnahmen entfernen?")
	return /** @type {LocalizedString} */ ("Remove all overrides?")
});